export default __webpack_public_path__ + "static/media/Ecommerce_Kahina_Giving_Beauty_-_Ethical_Luxury_Skin_Care_With_Argan_Oil.b7a53634.png";